import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// After a deploy, a tab still running the previous build asks for lazy chunks whose hashed
// filenames no longer exist (404). One reload fetches the fresh index.html and its chunks;
// the sessionStorage flag stops a reload loop if the failure is something else.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  try {
    if (sessionStorage.getItem('chunk-reload')) return
    sessionStorage.setItem('chunk-reload', '1')
  } catch {
    return
  }
  window.location.reload()
})
setTimeout(() => {
  try {
    sessionStorage.removeItem('chunk-reload')
  } catch {
    /* storage unavailable */
  }
}, 10000)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
